import { createActions } from "redux-actions";
import { sendMail as modelSendMail } from "../model/mail";
import { getDateRanges } from "../model/dateranges";

const {
  setName,
  setSurname,
  setCountry,
  setPostcode,
  setEmail,
  setPhoneNumber,
  setNumRoomGuests,
  setRoomKind,
  setRoomDates,
  setSelectedExperiences,
  setNumSelectedExperiencesGuests,
  setExperiencesDates,
  setExperiencesTimes,
  setNotes,
  setHasExperience,
  setHasRoomKind,
  setStatus,
  setReservationType,
  setDateRanges,
  fieldChanged,
  focusOn,
  setNumTableGuests,
  setTableDate,
  setTableTime,
  setHasTable
} = createActions({
  SET_NAME: value => ({ field: "name", value }),
  SET_SURNAME: value => ({ field: "surname", value }),
  SET_COUNTRY: value => ({ field: "country", value }),
  SET_POSTCODE: value => ({ field: "postcode", value }),
  SET_EMAIL: value => ({ field: "email", value }),
  SET_PHONE_NUMBER: value => ({ field: "phoneNumber", value }),
  SET_NUM_ROOM_GUESTS: value => ({ field: "numRoomGuests", value }),
  SET_ROOM_KIND: value => ({ field: "roomKind", value }),
  SET_ROOM_DATES: value => ({ field: "roomDates", value }),
  SET_SELECTED_EXPERIENCES: value => ({ field: "selectedExperiences", value }),
  SET_NUM_SELECTED_EXPERIENCES_GUESTS: value => ({
    field: "numSelectedExperiencesGuests",
    value
  }),
  SET_EXPERIENCES_DATES: value => ({ field: "experiencesDates", value }),
  SET_EXPERIENCES_TIMES: value => ({ field: "experiencesTimes", value }),
  SET_NOTES: value => ({ field: "notes", value }),
  SET_HAS_EXPERIENCE: value => ({ field: "hasExperience", value }),
  SET_HAS_ROOM_KIND: value => ({ field: "hasRoomKind", value }),
  SET_STATUS: value => ({ field: "status", value }),
  SET_RESERVATION_TYPE: value => ({ field: "reservationType", value }),
  SET_DATE_RANGES: value => ({ field: "dateRanges", value }),
  FIELD_CHANGED: fieldName => ({ fieldName }),
  FOCUS_ON: fieldName => ({ fieldName }),
  SET_NUM_TABLE_GUESTS: value => ({ field: "numTableGuests", value }),
  SET_TABLE_DATE: value => ({ field: "tableDate", value }),
  SET_TABLE_TIME: value => ({ field: "tableTime", value }),
  SET_HAS_TABLE: value => ({ field: "hasTable", value })
});

const sendMail = sendMailOptions => async dispatch => {
  dispatch(setStatus("sending-mail"));
  try {
    await modelSendMail(sendMailOptions);
  } catch (e) {
    console.error(e);
  } finally {
    dispatch(setStatus("confirmed"));
  }
};

const startup = () => async dispatch => {
  const dateRanges = await getDateRanges();
  dispatch(setDateRanges(dateRanges));
};

export {
  setName,
  setSurname,
  setCountry,
  setPostcode,
  setEmail,
  setPhoneNumber,
  setNumRoomGuests,
  setRoomKind,
  setRoomDates,
  setSelectedExperiences,
  setNumSelectedExperiencesGuests,
  setExperiencesDates,
  setExperiencesTimes,
  setNotes,
  setHasExperience,
  setHasRoomKind,
  setStatus,
  sendMail,
  setReservationType,
  setDateRanges,
  startup,
  fieldChanged,
  focusOn,
  setNumTableGuests,
  setTableDate,
  setTableTime,
  setHasTable
};
